<template>
    <div class="flex-level flex-top">
        <div class="flex flex-row">
            <avatar :avatar="person.avatar" size="big" />
            <div class="dinlineb valign-middle ml-3">
                <h4 class="mt-0 mb-1">
                    <a
                        :href="'/peoples/' + person.peopleId"
                        :class="person.isArchived ? 'gray-60' : 'black-link semibold'"
                    >
                        {{ civilityName }}
                    </a>
                </h4>
                <div v-if="person.position" class="fs-3 gray-60">
                    {{ person.position }}
                </div>
                <div v-if="person.mainContactDunning" class="fs-3 gray-60">
                    {{ $l10n.__('Contact de relance') }}
                </div>
            </div>
        </div>

        <!-- CTA -->
        <div class="flex">
            <ul class="m-0">
                <!-- EMAIL -->
                <li v-if="person.email !== ''" class="mb-1 fs-3 mb-1 copy-element">
                    <i class="icon-email mr-2 gray-60"></i>
                    <email-link
                        linkedtype="people"
                        :linkedid="parseInt(person.peopleId)"
                        :disabled="person.isArchived"
                        :email="person.email"
                        class="regular"
                    >
                        {{ person.email }}
                    </email-link>
                    <SaasClipboard v-if="person.email" :data="person.email" />
                </li>
                <!-- PHONE -->
                <li v-if="person.phone !== ''" class="mb-1 fs-3 mb-1 copy-element">
                    <i class="icon-sellsyphone mr-2 gray-60"></i>
                    <a
                        :href="phonecallProtocol + ':' + person.phone.replace(/[^\+\d]/g, '')"
                        :class="person.isArchived ? 'gray-60' : 'black-link'"
                    >
                        {{ person.phone }}
                    </a>
                    <SaasClipboard v-if="person.phone" :data="person.phone" />
                </li>
                <!-- MOBILE -->
                <li v-if="person.mobile !== ''" class="mb-1 fs-3 mb-1 copy-element">
                    <i class="icon-sellsyphone mr-2 gray-60"></i>
                    <a
                        :href="phonecallProtocol + ':' + person.mobile.replace(/[^\+\d]/g, '')"
                        :class="person.isArchived ? 'gray-60' : 'black-link'"
                    >
                        {{ person.mobile }}
                    </a>
                    <SaasClipboard v-if="person.mobile" :data="person.mobile" />
                </li>
            </ul>
        </div>
        <slot></slot>
        <!-- OPTION DROPDOWN -->
        <div v-if="person.actions && person.actions.length > 0">
            <DropdownMultiLevel
                :actions="person.actions"
                :permissions="permissions"
                @clicked="(clickedValue) => $emit('clicked', clickedValue, person)"
            />
        </div>
    </div>
</template>

<script>
import EmailLink from 'vcomponents/email/EmailLink.vue';
import SaasClipboard from 'vcomponents/utilities/SaasClipboard.vue';
import Avatar from 'vcomponents/utilities/Avatar.vue';
import DropdownMultiLevel from 'vcomponents/utilities/DropdownMultiLevel.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('corp');

export default {
    components: {
        'email-link': EmailLink,
        SaasClipboard,
        Avatar,
        DropdownMultiLevel,
    },
    props: {
        person: {
            type: Object,
            required: true,
            default: () => {},
        },
        permissions: {
            type: [Array, Object],
            required: false,
            default: () => [],
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapState(['phonecallProtocol']),
        civilityName() {
            return this.person.civility !== ''
                ? this.person.civility + ' ' + this.person.fullName
                : this.person.fullName;
        },
    },
};
</script>
